import { useState } from "react";
import StudentHeader from "./Header/StudentHeader";
import NavigationDrawer from "./Drawer/Drawer";
// Import other pages

function StudentHeaderAndDrawer() {
  //This is the state of the drawer
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  return (
    <>
      <StudentHeader isOpen={isOpen} toggleDrawer={toggleDrawer} />
      <NavigationDrawer
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
        setIsOpen={setIsOpen}
      />
    </>
  );
}

export default StudentHeaderAndDrawer;
